import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ROOT_FOLDER } from "../../../customHooks/FileManager/useFolder";
import { folderType } from "../../../customHooks/FileManager/useFolderTypes";
import "./FolderBreadCrumb.scss";
import { RootState } from "../../../redux/rootReducers";
import { useSelector } from "react-redux";

type AppProps = {
  folder: folderType;
  company_name?: string;
  client_code?: number | null;
  type?: string;
};

const FolderBreadCrumbs = ({
  folder,
  company_name,
  client_code,
  type,
}: AppProps) => {
  const currentDirPath = useSelector(
    (state: RootState) => state.fileManager.currentDirPath
  );
  const currentFolderDetails = useSelector(
    (state: RootState) => state.fileManager.currentFolderDetails
  );

  let path = currentFolderDetails?.name === "Home" ? [] : [ROOT_FOLDER];

  if (currentDirPath && currentDirPath?.length > 0) {
    path = [...path, ...currentDirPath];
  }

  const renderBreadCrumbs = () => {
    let finalBreadCrumb = path?.map((breadCrumb: any, index: number) => {
      const finalLink = {
        pathname: `/file-manager/${client_code}/folder/${breadCrumb?.id}`,
        state: {
          client_code,
          company_name,
          folder: {
            id: breadCrumb?.id,
            name: breadCrumb?.name,
            // full_path: path?.slice(1, index)
          },
        },
      };

      const renderBreadCrumbsData = () => {
        return (
          <div
            key={breadCrumb?.id}
            className="d-flex flex-row"
            style={breadCrumb?.name.length > 20 ? { width: "100px" } : {}}
          >
            <h6
              className="breadcrumb-name m-0"
              style={
                (path?.length !== 0 && breadCrumb?.name === "Home") ||
                breadCrumb?.name !== "Home"
                  ? {
                      height: "fit-content",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }
                  : {}
              }
            >
              {breadCrumb?.name}
            </h6>
            <p
              style={{
                marginLeft: "5px",
                marginRight: "5px",
                marginBottom: "0",
                textDecoration: "none",
              }}
            >
              /
            </p>
          </div>
        );
      };

      return type ? (
        <div>{renderBreadCrumbsData()}</div>
      ) : (
        <Link className="bread-link" to={finalLink}>
          {renderBreadCrumbsData()}
        </Link>
      );
    });

    return finalBreadCrumb;
  };

  return (
    <div
      className="d-flex flex-row"
      style={{ marginLeft: "-5px", flexWrap: "wrap" }}
    >
      {renderBreadCrumbs()}
      {currentFolderDetails?.name !== "Home" ? (
        <h6 className="breadcrumb-name m-0" style={{ height: "fit-content" }}>
          {currentFolderDetails && currentFolderDetails?.name}
        </h6>
      ) : (
        ""
      )}
    </div>
  );
};

export default FolderBreadCrumbs;
